export default "__VITE_ASSET__AD4pASQ2__"